import { api, config, partnerApi, StoreKey } from "../../configs/api";
import { ELIGIBLE_LIMIT, getParameters, getParametersFromURL, getTargetParamFromURL, nextStepCredStepper, nextStepId, removeUrlWithoutReload, showSupportNUmberForPartner, showSupportNumberForAllCustomer, switchToSpecificRoutes } from "../../configs/utils";
import { ROUTE } from "../../routes";
import SharedPropsService, { USERTYPE } from "../../SharedPropsService";
import { getAppHeader, initializeFirebase } from "../../configs/config";
import { ImportScriptSrc, LENDER_ID, QUERY_PARAMS, TARGET_PAGES } from "../../configs/constants";
import { APPLICATION_STATE } from "../../configs/constants";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { Platform } from "react-native";
import { MutualAmountValueToBackend } from "../AskMutualFund/askMutualFund/types";
import sharedPropsService from "../../SharedPropsService";
import { phonePayRoutes } from "../../configs/utils";
import { StepperStateToken } from "@voltmoney/schema";
export const SplashAction = async (action, _datastore, { network, navigate, asyncStorage, importScript, metaData, navigateWithClear, initializeAmplitude, instrumentTrack, initializeAmplitudeWithDeviceID, openNewTab }) => {
    const skipToStep = action.payload.skipToStep;
    const trackingId = action?.payload?.trackingId;
    // const isSeen = await SharedPropsService.getOnboarding();
    // if (isSeen) {
    if (metaData.platform.OS === 'web') {
        importScript(ImportScriptSrc.DIGIO_SCRIPT);
    }
    await initializeFirebase();
    if (Platform.OS !== 'web') {
        const fetchedConfig = await asyncStorage.get("remoteConfig");
        if (fetchedConfig) {
            const parsedConfig = JSON.parse(fetchedConfig);
            await SharedPropsService.setFirebaseConfig(parsedConfig);
        }
    }
    initializeAmplitude('', config.AMPLITUDE_CONFIG);
    const isFirstTime = await AsyncStorage.getItem('first_time');
    let accessToken = await SharedPropsService.getToken();
    const newUrl = Platform.OS === 'web' ? window.location.href : '';
    const newParams = Platform.OS === 'web' ? getParameters(newUrl) : {};
    const ref = newParams?.[QUERY_PARAMS.REF];
    const utmSource = newParams?.utm_source;
    if (accessToken) {
        await sharedPropsService.setToken(accessToken);
    }
    let localToken = await asyncStorage.get(StoreKey.accessToken);
    if (localToken && Platform.OS === 'web') {
        await sharedPropsService.setToken(localToken);
        asyncStorage.remove(StoreKey.accessToken);
        accessToken = localToken;
    }
    if (Platform.OS === 'web') {
        const params = getParametersFromURL();
        const amplitudeDeviceId = params?.[QUERY_PARAMS.AMPLITUDE_DEVICE_ID];
        if (amplitudeDeviceId) {
            await initializeAmplitudeWithDeviceID(amplitudeDeviceId);
        }
    }
    if (trackingId) {
        instrumentTrack("PLJ_REDIRECT_USER_TO_APP", { trackingId: trackingId });
    }
    instrumentTrack("LAUNCH_PAGE_VIEWED", ref ? { referral_code: ref } : {});
    if (accessToken || localToken) {
        const body = {};
        /*** NOT PASSING REF CODE HERE ***/
        const userType = await SharedPropsService.getUserType();
        if (userType === USERTYPE.BORROWER) {
            const userContextResponse = await network.post(api.userContext, body, {
                headers: await getAppHeader(),
            });
            if (userContextResponse.status === 200) {
                const user = userContextResponse.data;
                if (Platform.OS === 'web') {
                    const applicationState = user.linkedApplications[0].applicationState;
                    try {
                        const currentApplicationState = await AsyncStorage.getItem("applicationState");
                        if (currentApplicationState === APPLICATION_STATE.IN_PROGRESS && applicationState === APPLICATION_STATE.COMPLETED) {
                            await AsyncStorage.setItem("applicationState", applicationState);
                        }
                        else if (!currentApplicationState) {
                            await AsyncStorage.setItem("applicationState", applicationState);
                        }
                    }
                    catch (error) {
                        console.error("Error saving application state", error);
                    }
                    action?.payload?.setApplicationState(applicationState);
                }
                let applicationId;
                if (await AsyncStorage.getItem("application_id")) {
                    applicationId = await AsyncStorage.getItem("application_id");
                }
                else {
                    applicationId = userContextResponse.data.linkedApplications[0].applicationId;
                }
                const pledgeLimitResponse = await network.get(`${api.pledgeLimit}${user.linkedApplications[0].applicationId}`, { headers: await getAppHeader() });
                const availableCreditAmount = pledgeLimitResponse.data.stepResponseObject.availableCreditAmount ||
                    0;
                const totalPortfolioAmount = pledgeLimitResponse.data.stepResponseObject.totalPortfolioAmount ||
                    0;
                const showSupportNumber = await showSupportNumberForAllCustomer(userContextResponse.data);
                const showSupportNUmberForPartnerCustomer = await showSupportNUmberForPartner();
                if (availableCreditAmount >= ELIGIBLE_LIMIT.MIN_LIMIT || totalPortfolioAmount >= ELIGIBLE_LIMIT.MAX_AMOUNT || showSupportNumber) {
                    if (Platform.OS === 'web') {
                        action?.payload?.setShowSupportPhoneNumber(true);
                    }
                    await SharedPropsService.setSupportPhoneNumber(true);
                }
                else {
                    if (Platform.OS === 'web') {
                        action?.payload?.setShowSupportPhoneNumber(showSupportNUmberForPartnerCustomer);
                    }
                    await SharedPropsService.setSupportPhoneNumber(showSupportNUmberForPartnerCustomer);
                }
                if (user.linkedApplications[0].accountId) {
                    initializeAmplitude(user.linkedApplications[0].accountId);
                }
                await SharedPropsService.setUser(user);
                action?.payload?.setIsUserLoggedIn(user);
                const url = Platform.OS === 'web' ? window.location.href : '';
                const params = Platform.OS === 'web' ? getParameters(url) : {};
                const isFromPhonePe = params?.platform === "PHONEPE" /* AppPlatform.PHONEPE */;
                const utmCampaign = params?.utm_source;
                const showAskMF = await sharedPropsService.getShowAskMF();
                /****
                 * ADD YOUR CUSTOM ROUTE TO NAVIGATE
                 * ****/
                if (user.linkedApplications[0].applicationState === "COMPLETED" && user.linkedBorrowerAccounts[0].accountState === "ACTIVE") {
                    let availableCreditAmount;
                    let isPendingDisbursal;
                    let allowForeclosure = true;
                    let dontAllowHome = params?.showPostLoanJourney;
                    if (dontAllowHome === "false" || params?.platform === "BHARAT_PE" || params?.platform === "PHONEPE" /* AppPlatform.PHONEPE */) {
                        await SharedPropsService.setAllowHome(false);
                    }
                    else {
                        await SharedPropsService.setAllowHome(true);
                    }
                    if (dontAllowHome === "false" || params?.platform === "BHARAT_PE" || params?.platform === "PHONEPE" /* AppPlatform.PHONEPE */) {
                        return navigate(ROUTE.CREDIT_LOADING_SCREEN, { showDownloadAppScreen: true });
                    }
                    const target = await AsyncStorage.getItem("target");
                    if (await SharedPropsService.getAppPlatform() === "PHONEPE" /* AppPlatform.PHONEPE */ && utmSource !== QUERY_PARAMS.PHONE_PE_FJ) {
                        return navigate(ROUTE.PHONE_PAY_PAGE);
                    }
                    if (getTargetParamFromURL() === "withdraw" || target === "withdraw") {
                        const response = await network.get(`${api.getCredit}/${userContextResponse.data.linkedCredits[0].creditId}`, {
                            headers: await getAppHeader(),
                        });
                        const isPendingDisbursalResponse = await network.get(`${api.getPendingDisbursal}${userContextResponse?.data?.linkedCredits[0]?.creditId}`, {
                            headers: await getAppHeader(),
                        })
                            .then(response => response.data);
                        availableCreditAmount = response.data.availableCreditAmount;
                        isPendingDisbursal = isPendingDisbursalResponse?.data?.isPendingDisbursal;
                    }
                    if (getTargetParamFromURL() === TARGET_PAGES.FORECLOSURE) {
                        const manageLimitConfig = await network
                            .get(`${api.manageLimitConfig}${user.linkedCredits[0].creditId}`, { headers: await getAppHeader() });
                        allowForeclosure = manageLimitConfig?.loanForeClosureAllowed;
                    }
                    await switchToSpecificRoutes(userContextResponse.data, availableCreditAmount, navigate, isPendingDisbursal, allowForeclosure);
                }
                else {
                    if (user.linkedApplications[0].applicationState === "BLOCKED") {
                        return navigate(ROUTE.APPLICATION_PENDING_BLOCKING_SCREEN, { applicationState: APPLICATION_STATE.BLOCKED });
                    }
                    else if (user.linkedApplications[0].applicationState === "DENIED") {
                        return navigate(ROUTE.APPLICATION_PENDING_BLOCKING_SCREEN, { applicationState: APPLICATION_STATE.DENIED });
                    }
                    else if (params?.plj && userContextResponse?.data?.linkedBorrowerAccounts[0]?.accountHolderEmail === null) {
                        return navigate(ROUTE.ENTER_EMAIL);
                    }
                    else if (user.linkedApplications[0].stepStatusMap.DOCUMENTS ===
                        StepperStateToken.PENDING_MANUAL_VERIFICATION) {
                        navigate(ROUTE.AS_ES_DOCUMENT_IN_REVIEW, {});
                    }
                    else if (user.linkedApplications[0].stepStatusMap.DOCUMENTS ===
                        StepperStateToken.FAILED) {
                        navigate(ROUTE.AS_ES_DOCUMENT_REJECTED, {});
                    }
                    else if (parseInt(skipToStep) === 1) {
                        removeUrlWithoutReload("sts");
                        let applicationId;
                        if (await AsyncStorage.getItem("application_id")) {
                            applicationId = await AsyncStorage.getItem("application_id");
                        }
                        else {
                            applicationId = user.linkedApplications[0].applicationId;
                        }
                        const userApplication = await network.get(`${api.borrowerApplication}${applicationId}`, { headers: await getAppHeader() }).then(response => response.data);
                        const routeObj = await nextStepCredStepper(userApplication.currentStepId);
                        navigate(routeObj.routeId, routeObj.params);
                    }
                    else {
                        Platform.OS === 'web' && removeUrlWithoutReload(QUERY_PARAMS.TARGET);
                        const nextRoute = await nextStepId(user.linkedApplications[0].currentStepId);
                        if (await SharedPropsService.showHome()) {
                            console.warn("NEXT ROUTE ID IS", nextRoute.routeId);
                            if (await SharedPropsService.getAppPlatform() === "PHONEPE" /* AppPlatform.PHONEPE */ && !phonePayRoutes.includes(nextRoute.routeId) && utmSource !== QUERY_PARAMS.PHONE_PE_FJ) {
                                return navigate(ROUTE.PHONE_PAY_PAGE);
                            }
                            else if (params?.plj && userContextResponse?.data?.linkedBorrowerAccounts[0]?.accountHolderEmail === null) {
                                return navigate(ROUTE.ENTER_EMAIL);
                            }
                            else {
                                return navigate(ROUTE.BORROWER_LANDING_SCREEN);
                            }
                        }
                        else {
                            let isFromBajaj = user?.linkedApplications[0].lenderAccountId.toLowerCase() === LENDER_ID.BAJAJ;
                            if (await SharedPropsService.getAppPlatform() === "PHONEPE" /* AppPlatform.PHONEPE */ && !phonePayRoutes.includes(nextRoute.routeId) && utmSource !== QUERY_PARAMS.PHONE_PE_FJ) {
                                return navigate(ROUTE.PHONE_PAY_PAGE);
                            }
                            else if (isFromPhonePe && isFromBajaj && !phonePayRoutes.includes(nextRoute.routeId)) {
                                return navigate(ROUTE.PHONE_PAY_PAGE);
                            }
                        }
                        if (showAskMF && nextRoute.routeId === ROUTE.EMAIL_VERIFY) {
                            const userId = userContextResponse.data.user.userId;
                            const shouldShowAskMutualFund = await network.get(`${api.securityAssetConsent}${userId}`, { headers: await getAppHeader() });
                            const getUserAttributes = await network.get(`${api.userAttributes}${userId}`, { headers: await getAppHeader() });
                            const shouldCheckConsent = shouldShowAskMutualFund.data.shouldCheckConsent;
                            const existingConsent = shouldShowAskMutualFund.data.existingConsent;
                            const isAmountSelected = getUserAttributes.data.assetRange;
                            if (shouldCheckConsent && utmCampaign === 'Facebook') {
                                await navigateWithClear(ROUTE.ASK_MUTUAL_FUND_OLD);
                            }
                            else if (isAmountSelected === null && existingConsent === "YES") {
                                await navigateWithClear(ROUTE.ASK_MUTUAL_FUND);
                            }
                            else if (existingConsent === "NO" || (isAmountSelected === MutualAmountValueToBackend.AMOUNT_0K && existingConsent === "NO")) {
                                await navigateWithClear(ROUTE.NO_MUTUAL_FUND_INSTRUCTION);
                            }
                            else if ((isAmountSelected === MutualAmountValueToBackend.AMOUNT_0K && existingConsent === "YES") || (nextRoute.routeId === ROUTE.NO_MUTUAL_FUND_INSTRUCTION && isAmountSelected === null && existingConsent === "YES")) {
                                await navigate(nextRoute.routeId, nextRoute.params);
                            }
                            else {
                                await navigate(nextRoute.routeId, nextRoute.params);
                            }
                        }
                        else {
                            await navigate(nextRoute.routeId, nextRoute.params);
                        }
                    }
                }
            }
            else {
                await navigate(ROUTE.PHONE_NUMBER, {
                    mobileNumber: action?.payload?.mobileNumber,
                });
                document.cookie = "access_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
            }
        }
        else {
            const userContextResponse = await network.post(partnerApi.userContext, body, {
                headers: await getAppHeader(),
            });
            const partnerUser = await (await SharedPropsService.getPartnerUser()).panNumber;
            if (userContextResponse.status === 200) {
                const user = userContextResponse.data;
                await SharedPropsService.setUser(user);
                // await navigate(ROUTE.PORTFOLIO_UNLOCK);
                // return;
                if (user.linkedPartnerAccounts[0].partnerName == null || user.linkedPartnerAccounts[0].accountHolderEmail == null) {
                    await navigate(ROUTE.ENTER_NAME);
                }
                else if (user.linkedPartnerAccounts[0].partnerName != null) {
                    await navigate(ROUTE.DISTRIBUTOR_CLIENT_LIST);
                }
                else if (partnerUser !== '') {
                    await navigate(ROUTE.DISTRIBUTOR_PORTFOLIO);
                }
                else {
                    await navigate(ROUTE.DISTRIBUTOR_CLIENT_LIST);
                }
            }
        }
    }
    else {
        //@ts-ignore
        let showIntroCardPhonePe = await SharedPropsService.getFirebaseConfig().show_intro_page_phonepe === true || await SharedPropsService.getFirebaseConfig().show_intro_page_phonepe === "true";
        if (Platform.OS !== "web" && (isFirstTime === 'false' || isFirstTime === null) || (await SharedPropsService.getAppPlatform() === "PHONEPE" /* AppPlatform.PHONEPE */ && (isFirstTime === 'false' || isFirstTime === null) && showIntroCardPhonePe)) {
            await navigate(ROUTE.CAROUSAL_PAGE);
        }
        else {
            await navigate(ROUTE.PHONE_NUMBER, {
                mobileNumber: action?.payload?.mobileNumber,
            });
        }
    }
    // } else {
    //   await navigate(ROUTE.LANDING_PAGE);
    // }
};
